module.exports = __webpack_public_path__ + "static/media/downarrow.669dad49.svg";